import styled from "styled-components";

export const GROUP_CART_HEADER_HEIGHT = "116px";

export const Container = styled.div(({ theme }) => {
    return {
        display: "flex",
        width: "100%",
        height: "100%",
        flexDirection: "column",
        background: theme.colors[theme.colorMode].background_Secondary,
    };
});

export const Header = styled.div(({ theme }) => {
    return {
        display: "flex",
        overflow: "hidden",
        width: "100%",
        alignItems: "flex-start",
        background: theme.colors[theme.colorMode].background_Primary,
        height: GROUP_CART_HEADER_HEIGHT,
        minHeight: GROUP_CART_HEADER_HEIGHT,

        "@supports (padding-top: var(--sat, 0px))": {
            paddingTop: "var(--sat, 0px)",
            height: `calc(var(--sat, 0px) + ${GROUP_CART_HEADER_HEIGHT})`,
            minHeight: `calc(var(--sat, 0px) + ${GROUP_CART_HEADER_HEIGHT})`,
        },
    };
});

export const Content = styled.div(({ theme }) => {
    return {
        width: "100%",
        height: `calc(100% - ${GROUP_CART_HEADER_HEIGHT})`,
        background: theme.colors[theme.colorMode].background_Secondary,
        overflow: "scroll",
    };
});
